import { useLazyQuery, gql } from '@apollo/react-hooks';
import { getModelList } from '#/graphql/queries';
import type { GetModelListQuery, GetModelListQueryVariables } from '#/graphql/types';

const q = gql(getModelList);

const useModelListLazyQuery = (variables: GetModelListQueryVariables = {}) => {
  const [fetchModelList] = useLazyQuery<GetModelListQuery, GetModelListQueryVariables>(q, {
    variables,
    fetchPolicy: 'cache-and-network',
  });

  return fetchModelList;
};

export default useModelListLazyQuery;
